import React, { useState } from "react"
import { ActionDrawerProps } from "./types"
import { Box, Drawer, IconButton, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { icons } from "../../utils/icons"

const ActionDrawer = ({ children, header: HeaderNode, body: Node, title, container }: ActionDrawerProps) => {
    const styles = useStyles()
    const [open, setOpen] = useState(false)

    const openDrawer = () => {
        setOpen(true)
    }

    const closeDrawer = () => {
        setOpen(false)
    }

    return (
        <>
            {children({ open, openDrawer, closeDrawer })}

            <Drawer open={open} anchor="right">
                <Box {...container} sx={{ ...styles.container, ...container?.sx }}>
                    <Box sx={styles.header}>
                        {typeof HeaderNode === 'function' && HeaderNode.prototype?.isReactComponent === undefined && <HeaderNode close={closeDrawer} />}
                        {React.isValidElement(HeaderNode) && HeaderNode}

                        {!HeaderNode && (
                            <>
                                {!!title ? <Typography variant="subtitle" fontWeight='bold' color='primary.100'>{title}</Typography> : <Box />}

                                <IconButton onClick={closeDrawer}>{icons('simple-close')}</IconButton>
                            </>
                        )}
                    </Box>

                    {typeof Node === 'function' && Node.prototype?.isReactComponent === undefined && <Node close={closeDrawer} />}
                    {React.isValidElement(Node) && Node}
                </Box>
            </Drawer>
        </>
    )
}

export { ActionDrawer }